import { render, staticRenderFns } from "./Charttwo.vue?vue&type=template&id=0a0d1ab6"
import script from "./Charttwo.vue?vue&type=script&lang=js"
export * from "./Charttwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports